import * as React from 'react';
import {connect} from 'react-redux';
import {RouteComponentProps} from 'react-router-dom';
import Button from '@components/common/button/Button';
import BottomBar from '@components/calendar2/fab/BottomBar';
import {IArticleTarget} from '@app-types/article.types';
import {openArticle} from '@services/article/article.actions';
import {fullViewportColumn} from 'src/main.style';
import {WebsiteFrame} from './WebsiteFrame';
import {articleTargetForLink, browsingUrl, IEmbedNavigation, isSwedish, knowledgeRoot, knowledgeTitle, validatedEmbedNavigation} from './articleNavigation';

interface IProps extends RouteComponentProps {
  language: string;
  isChild: boolean;
  openArticle: (target: IArticleTarget) => void;
}

interface IState {
  path?: string;
  country?: string;
}

export class KnowledgeContainer extends React.Component<IProps, IState> {
  public state: IState = {};

  public componentDidMount() {
    this.openIncomingArticle();
  }

  public componentDidUpdate(previous: IProps) {
    if (previous.location.pathname !== this.props.location.pathname || previous.location.search !== this.props.location.search) {
      this.openIncomingArticle();
    }
  }

  public render() {
    const {language, isChild} = this.props;
    const src = browsingUrl(language, this.state.path, isChild, this.state.country);
    const root = knowledgeRoot(language, isChild);
    const atRoot = src === browsingUrl(language, root, isChild, this.state.country);
    return (
      <div style={{...fullViewportColumn, paddingBottom: 76, boxSizing: 'border-box', background: '#fff'}}>
        {!atRoot && (
          <div style={{padding: '8px 16px'}}>
            <Button onClick={() => this.setState({path: root})}>{isSwedish(language) ? 'Alla kategorier' : 'All categories'}</Button>
          </div>
        )}
        <WebsiteFrame key={src} src={src} title={knowledgeTitle(language)} language={language}
          onNavigate={this.navigate}/>
        <BottomBar hidden={false} displaySubmenyCallback={() => undefined}/>
      </div>
    );
  }

  private openIncomingArticle = () => {
    // Support externally supplied legacy URLs once, without changing the URL to open or close the modal.
    const target = articleTargetForLink(this.props.location.pathname + this.props.location.search);
    if (target) this.props.openArticle(target);
  };

  private navigate = (message: IEmbedNavigation) => {
    const navigation = validatedEmbedNavigation(message);
    if (!navigation) return;
    if (navigation.kind === 'article') {
      this.props.openArticle({reference: navigation.value, country: navigation.country});
    } else if (navigation.kind === 'browse') {
      this.setState({path: navigation.value, country: navigation.country});
    } else {
      this.props.history.push(navigation.value);
    }
  };
}

export default connect((state: any) => ({
  language: state.user.language || 'EN',
  isChild: (state.family.family || []).some((member: any) => member.id === state.user.session.data.id && member.role === 'CHILD'),
}), {openArticle})(KnowledgeContainer);



// WEBPACK FOOTER //
// ./src/containers/knowledge/knowledge.container.tsx